<template>
  <loading v-if="loading" />
  <div v-else>
    <div class="p-6" v-if="activity">
      <div
        class="text-center mb-4"
        :style="{color: activityCategory.color}"
        v-if="activityCategory"
      >
        <icon :name="activityCategory.icon" size="2em" />
      </div>
      <h2 class="mb-0 leading-tight text-center">{{ activity.title }}</h2>
      <p class="text-center tracking-wide" v-if="activityCategory">{{ activityCategory.title }}</p>
      <p class="italic tracking-wide text-center">
        <span v-if="lastDate">{{ lastDate }}</span>
      </p>
      <div class="w-full mt-2 text-center" v-if="!isUserActivity">
        <wd-button
          black
          icon="Plus"
          icon-stroke="2"
          icon-size="1em"
          @input="addUserActivity"
        >{{ $tc("activities.favorite", 1) }}</wd-button>
      </div>
      <div class="w-full mt-2 text-center">
        <wd-button
          black
          icon="Target"
          icon-stroke="2"
          icon-size="1em"
          @input="openCreateTarget"
        >{{ $t('targets.create.create_target') }}</wd-button>
      </div>
      <div class="text-sm grid items-center justify-center border-t border-b mt-8 mb-4 py-4">
        <p class="text-5xl mr-2 text-center leading-none">{{ totalCount || 0 }}x</p>
        <p class="text-center">{{ $t("general.finished") }}</p>
        <div v-if="!finished">
          <wd-button class="text-base items-center" feature @input="finishActivity">
            <icon name="Check" size="1.4em" />
            {{ $t("general.finish") }}
          </wd-button>
        </div>
      </div>
      <div class="mt-6 mb-2 flex justify-around">
        <activity-week
          clickable
          :days="
            entries
              ? entries
                  .filter((e) => checkDate(e.created_at, -8))
                  .map((e) => e.created_at)
              : []
          "
        />
      </div>
    </div>
    <tabs popped>
      <tab @input="open('today')" popped :active="area === 'today'">
        {{
        $t("general.today")
        }}
      </tab>
      <tab @input="open('week')" popped :active="area === 'week'">
        {{
        $t("general.this_week")
        }}
      </tab>
    </tabs>
    <div class="p-6 italic text-sm stack-sm">
      {{
      $t("activities.percent_finished_all_users", {
      percent: Math.round(allPercentages[area]),
      time: areaWord,
      })
      }}
      <progress-bar class="mb-3" :amount="allPercentages[area]" />
      {{
      $t("activities.percent_finished_friends", {
      percent: Math.round(friendPercentages[area]),
      time: areaWord,
      })
      }}
      <progress-bar :amount="friendPercentages[area]" />
    </div>
  </div>
</template>

<script>
import { Activity } from "@/modules/activities/viewmodels/Activity";
import DateMixin from "@/mixins/DateMixin";

const Tab = require("@/modules/core/components/Tab.vue").default;
const Tabs = require("@/modules/core/components/Tabs.vue").default;
const ProgressBar = require("@/modules/core/components/ProgressBar.vue")
  .default;
const ActivityWeek = require("@/modules/activities/components/ActivityWeek.vue")
  .default;

export default {
  name: "ActivityDetailSite",
  mixins: [DateMixin],
  data() {
    return {
      area: "today",
      sending: false,
      friendPercentages: {
        today: 0,
        week: 0
      },
      allPercentages: {
        today: 0,
        week: 0
      },
      activityCategory: null,
      totalCount: 0
    };
  },
  props: {
    id: {
      type: String,
      default: null
    }
  },
  components: {
    Tab,
    Tabs,
    ProgressBar,
    ActivityWeek
  },
  methods: {
    async getActivity() {
      let activity = await this.$store.getters["activity/api"].Show(this.id);
      this.activityCategory = await this.$store.getters[
        "activitycategory/api"
      ].Show(activity.activity_category_id);
      return activity;
    },
    async getEntries() {
      return await this.$store.getters["activityentry/api"].Custom.ActivityWeek(
        this.id
      );
    },
    async getPercentages() {
      this.friendPercentages.today = await this.$store.getters[
        "activityentry/api"
      ].Custom.ActivityPercentageDayFriends(this.id);
      this.friendPercentages.week = await this.$store.getters[
        "activityentry/api"
      ].Custom.ActivityPercentageWeekFriends(this.id);
      this.allPercentages.today = await this.$store.getters[
        "activityentry/api"
      ].Custom.ActivityPercentageDayAll(this.id);
      this.allPercentages.week = await this.$store.getters[
        "activityentry/api"
      ].Custom.ActivityPercentageWeekAll(this.id);
    },
    open(link) {
      this.area = link;
    },
    openCreateTarget() {
      this.$router.push({
        path: "/create-target",
        query: { activity: this.id }
      });
    },
    getUserActivityForActivity(Id) {
      return this.$store.getters["useractivity/userActivityForActivity"](Id);
    },
    async addUserActivity() {
      return await this.$store.getters["useractivity/api"].Create({
        activity_id: this.id
      });
    },
    async removeUserActivity() {
      let userActivity = this.getUserActivityForActivity(this.id);
      await this.$store.getters["useractivity/api"]
        .Destroy(userActivity.id)
        .then()
        .catch(e => {
          this.popup({
            type: "alert",
            title: this.$t("general.error"),
            text: this.$t("activities.no_activityentry_found")
          });
        });
    },
    async deleteCustomActivity() {
      this.$store.getters["activity/api"]
        .Destroy(this.id)
        .then(() => {
          this.goTo("/activities");
        })
        .catch(e => {
          this.popup({
            type: "alert",
            title: this.$t("general.error"),
            text: this.$t("activities.error_delete_message")
          });
        });
    },
    updateHeader(Bool) {
      let elements = [
        {
          value: this.$t("activities.activity_details"),
          css: "tracking-widest font-medium"
        }
      ];

      if (Bool === true) {
        elements.push({
          type: "icon",
          value: "Star",
          iconSettings: { filled: true },
          location: "right",
          action: () => {
            this.removeUserActivity();
          }
        });
      } else {
        elements.push({
          type: "icon",
          value: "Star",
          iconSettings: { filled: false },
          location: "right",
          action: () => {
            this.addUserActivity();
          }
        });
      }

      if (this.activity.type === "custom") {
        elements.push({
          type: "dropdown",
          location: "right",
          elements: [
            {
              value: "Löschen",
              action: () => {
                this.deleteCustomActivity();
              }
            }
          ]
        });
      }

      this.$store.dispatch("header/update", {
        elements: elements,
        backbutton: true,
        clear: true
      });
    },
    async finishActivity() {
      if (this.sending) return;
      this.sending = true;
      await this.$store.getters["activityentry/api"].Custom.Check(this.id);
      this.popup({
        type: "success",
        title:
          this.$tc("activities.activity", 1) +
          " " +
          this.$t("general.finished"),
        text: this.$t("activities.activity_finished_message", {
          activity: this.activity.title
        })
      });
      this.sending = false;
      this.getPercentages();
      this.totalCount++;
    },
    async unFinishActivity() {
      if (this.sending) return;
      this.sending = true;
      await this.$store.getters["activityentry/api"].Custom.Uncheck(this.id);
      this.popup({
        type: "info",
        title: this.$t("general.reverted_changes"),
        text: this.$t("activities.reverted_changes_message", {
          activity: this.activity.title
        })
      });
      this.sending = false;
      this.getPercentages();
      this.totalCount--;
    }
  },
  computed: {
    activity() {
      return this.$store.getters["activity/activity"](this.id);
    },
    entries() {
      return this.$store.getters["activityentry/entriesForActivity"](this.id);
    },
    areaWord() {
      return this.area === "today"
        ? this.$t("general.today")
        : this.$t("general.this_week");
    },
    isUserActivity() {
      return this.$store.getters["useractivity/isUserActivity"](this.id);
    },
    lastEntry() {
      return this.entries && this.entries.length > 0
        ? this.entries.slice(-1)[0]
        : false;
    },
    lastDate() {
      return this.lastEntry ? this.getDate(this.lastEntry.created_at) : false;
    },
    finished() {
      return this.lastEntry ? this.isToday(this.lastEntry.created_at) : false;
    }
  },
  async created() {
    await this.getActivity();
    await this.getEntries();
    await this.getPercentages();

    let totalCount = await this.$store.getters[
      "activityentry/api"
    ].Custom.ActivityStats(this.id, { range: 0 });

    this.totalCount = totalCount ? totalCount.total : 0;

    this.updateHeader(this.isUserActivity);
    await this.$store.getters["useractivity/api"].Custom.My();
    this.loading = false;
  },
  watch: {
    isUserActivity(newVar) {
      this.updateHeader(newVar);
    }
  }
};
</script>
